.form {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}
